<div class="totalContainer">
  <div class="header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="loader">
            <h1>
              NEW REVOLUTIONIZED <br />
              INTERNET MARKETING SOLUTIONS
            </h1>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="min_box">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-lg-4">
          <div class="left_box mb-4">
            <h1 class="ml1">
              <span class="text-wrapper">
                <span class="line line1"></span>
                <span class="letters">LAUNCHING SOON!</span>
                <span class="line line2"></span>
              </span>
            </h1>
            <p>
              What if you can have a life-long passive income? ONPASSIVE gives
              you a once-in-a life-time opportunity to join an earning platform
              that is 100% automated with a customized business model to
              generate residual income which is always helpful. Bring a smile on
              your family member's faces this festive season as you do not have
              to think about expenses any more.
            </p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="mid_box">
            <div class="circal_image">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive-october(4)/images/circal_image.png"
                class="img-fluid"
                alt="image"
              />
            </div>
            <div class="circal_image_one">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive-october(4)/images/circal_image_one.png"
                class="img-fluid"
                alt="image"
              />
            </div>
            <div class="logo">
              <img
                src="{{ onPassiveBaseUrl }}onpassive-october(4)/images/logo.png"
                class="img-fluid"
                alt="logo"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="right_box">
          
            <div class="video_box acc_panel anim_in">
              <video
                id="my-video"
                class="video-js video-size w-100 h-auto"
                controls
                preload="auto"
                poster="{{
                  myLinksS3URL
                }}frontend/greetingsgofound3/images/greeting2.png"
                data-setup="{}"
                autoplay="true"
                muted
              >
                <source
                  src="{{
                    myLinksS3URL
                  }}videos/Onpassive_launching_page_video2.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-lg-4">
        <a
          href="/registration/user?reg={{ userId }}"
          name="regform"
          target="_blank"
          rel="noopener"
          class="btn11"
        >
          <span>BECOME A FOUNDER NOW</span>

          <div class="transition"></div>
        </a>
      </div>
    </div>
  </div>
</div>
